import '@/services/feature-toggle/feature-toggle';
import { configureCompat } from 'vue';

import registerNpsElement from '@/modules/nps/register-nps-element';
import { RegisterGlobalComponents } from './register-global-components';

configureCompat({
  GLOBAL_MOUNT: false,
  OPTIONS_DESTROYED: false,
  INSTANCE_SCOPED_SLOTS: false,
  FILTERS: false,
  RENDER_FUNCTION: false,
  GLOBAL_DELETE: false,
  GLOBAL_SET: false
});

registerNpsElement();
RegisterGlobalComponents.register();
